import { render, staticRenderFns } from "./RebalanceModal.vue?vue&type=template&id=01f6570a&scoped=true&"
import script from "./RebalanceModal.vue?vue&type=script&lang=js&"
export * from "./RebalanceModal.vue?vue&type=script&lang=js&"
import style0 from "./RebalanceModal.vue?vue&type=style&index=0&id=01f6570a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6570a",
  null
  
)

export default component.exports